<template>
  <div id="model-list-container" ref='model-list-container'>
    <div class="d-none d-lg-block d-xl-block">
      <b-row v-for="slice in sliced_items" :key="slice.counter" class="models-row">
        <b-col v-for="(item, index) in slice.chunk_data" lg=4 :key="item.id">
          <div  @click="showData(index, slice.counter)" 
                :class="{ active : chosen_idx == slice.counter * 3 + index }">
            <div class="model-item">
              <img class='center' v-bind:src="require('../assets/' + item.type.replace(' ', '_') + '.png')" alt="model icon">
              <p v-if="$store.getters.language === 'SLO'" class="align-center tool-title">
                {{item.name_slo}}
              </p>
              <p v-else class="align-center tool-title">
                {{item.name}}
              </p>
              <p v-if="$store.getters.language === 'SLO'" class="align-center tool-description">
                {{item.short_description_slo}}
              </p>
              <p v-else class="align-center tool-description">
                {{item.short_description}}
              </p>
            </div>
          </div>
          <p v-if="chosen_idx == slice.counter * 3 + index" class="align-center"><i class="arrow-down"></i></p>
        </b-col>
        <b-col lg=12>
          <div v-if="chosen_idx >= slice.counter * 3 && chosen_idx < (slice.counter + 1) * 3" class="outer">
            <div class="inner">
              <b-row>
                <b-col lg=8>


                  <span v-if="$store.getters.language === 'SLO'" class=tool-subtitle>Opis:</span>
                  <span v-else class=tool-subtitle>Description:</span>
                  <span v-if="$store.getters.language === 'SLO'">{{items[chosen_idx].description_slo}}</span>
                  <span v-else>{{items[chosen_idx].description}}</span>
                  
                  <span v-if="$store.getters.language === 'SLO'" class=tool-subtitle>Spletni vmesnik z navodili za uporabo:</span>
                  <span v-else class=tool-subtitle>API with instructions on how to use it: </span>
                  <a :href="items[chosen_idx].api_doc_url">{{items[chosen_idx].api_doc_url}}</a>
            
                  
                  <span v-if="$store.getters.language === 'SLO'" class=tool-subtitle>GIT repozitorij:</span>
                  <span v-else class=tool-subtitle>GIT repository:</span>
                  <a :href="items[chosen_idx].git_url">{{items[chosen_idx].git_url}}</a>
                  
             
                  <span v-if="$store.getters.language === 'SLO'" class=tool-subtitle>Znanstveni članek z opisom modela:</span>
                  <span v-else class=tool-subtitle>Paper describing the model:</span>
                  <a :href="items[chosen_idx].paper_url">{{items[chosen_idx].paper_url}}</a>
              
                  <span v-if="$store.getters.language === 'SLO'" class=tool-subtitle>Tip orodja:</span>
                  <span v-else class=tool-subtitle>Type of tool:</span>
                  <span v-if="$store.getters.language === 'SLO' && items[chosen_idx].type === 'Other'">Drugo</span>
                  <span v-else-if="$store.getters.language === 'SLO' && items[chosen_idx].type === 'Document classification'">Klasifikacija dokumentov</span>
                  <span v-else-if="$store.getters.language === 'SLO' && items[chosen_idx].type === 'Sequence labelling'">Označevanje sekvence</span>
                  <span v-else-if="$store.getters.language === 'SLO' && items[chosen_idx].type === 'LLM'">Jezikovni model</span>
                  <span v-else>{{items[chosen_idx].type}}</span>

                  <span v-if="$store.getters.language === 'SLO'" class=tool-subtitle>Objavljen:</span>
                  <span v-else class=tool-subtitle>Published:</span>
                  <span>{{items[chosen_idx].created_ts}}</span>

                  <b-button class="button-redirect" @click="redirectToGUI(items[chosen_idx].name, items[chosen_idx].name_slo, items[chosen_idx].type, items[chosen_idx].id, items[chosen_idx].git_url, items[chosen_idx].api_doc_url)">
                    <span v-if="$store.getters.language === 'SLO'">Preizkusi model</span>
                    <span v-else>Check out the model</span>
                  </b-button>
                </b-col>
                <b-col lg=4>
                  <p v-if="$store.getters.language === 'SLO'" class="align-center tool-title">{{items[chosen_idx].name_slo}}</p>
                  <p v-else class="align-center tool-title">{{items[chosen_idx].name}}</p>
                  <img class='center' v-bind:src="require('../assets/' + items[chosen_idx].type.replace(' ', '_') + '_white.png')" alt="model icon">    
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
    <div class="d-lg-none d-xl-none">
      <b-row v-for="(item, index) in items" :key="item.id">
        <b-col xs=12>
          <div  @click="showData(index)" 
                  :class="{ active : chosen_idx == index }">
            <div class="model-item">
              <img class='center' v-bind:src="require('../assets/' + item.type.replace(' ', '_') + '.png')" alt="model icon">
              <p v-if="$store.getters.language === 'SLO'" class="align-center tool-title">
                {{item.name_slo}}
              </p>
              <p v-else class="align-center tool-title">
                {{item.name}}
              </p>
              <p v-if="$store.getters.language === 'SLO'" class="align-center tool-description">
                {{item.short_description_slo}}
              </p>
              <p v-else class="align-center tool-description">
                {{item.short_description}}
              </p>
            </div>
          </div>
          <div v-if="chosen_idx == index" class="outer">
            <div class="inner">
              <span v-if="$store.getters.language === 'SLO'" class=tool-subtitle>Opis:</span>
              <span v-else class=tool-subtitle>Description:</span>
              <span v-if="$store.getters.language === 'SLO'">{{items[chosen_idx].description_slo}}</span>
              <span v-else>{{items[chosen_idx].description}}</span>
              
              <span v-if="$store.getters.language === 'SLO'" class=tool-subtitle>Spletni vmesnik z navodili za uporabo:</span>
              <span v-else class=tool-subtitle>API with instructions on how to use it:</span>
              <a :href="items[chosen_idx].api_doc_url">{{items[chosen_idx].api_doc_url}}</a>
        
              
              <span v-if="$store.getters.language === 'SLO'" class=tool-subtitle>GIT repozitorij:</span>
              <span v-else class=tool-subtitle>GIT repository:</span>
              <a :href="items[chosen_idx].git_url">{{items[chosen_idx].git_url}}</a>
              
         
              <span v-if="$store.getters.language === 'SLO'" class=tool-subtitle>Znanstveni članek z opisom modela:</span>
              <span v-else class=tool-subtitle>Paper describing the model:</span>
              <a :href="items[chosen_idx].paper_url">{{items[chosen_idx].paper_url}}</a>
          
              <span v-if="$store.getters.language === 'SLO'" class=tool-subtitle>Tip orodja:</span>
              <span v-else class=tool-subtitle>Type of tool:</span>
              <span v-if="$store.getters.language === 'SLO' && items[chosen_idx].type === 'Other'">Drugo</span>
              <span v-else-if="$store.getters.language === 'SLO' && items[chosen_idx].type === 'Document classification'">Klasifikacija dokumentov</span>
              <span v-else-if="$store.getters.language === 'SLO' && items[chosen_idx].type === 'Sequence labelling'">Označevanje sekvence</span>
              <span v-else-if="$store.getters.language === 'SLO' && items[chosen_idx].type === 'LLM'">Jezikovni model</span>
              <span v-else>{{items[chosen_idx].type}}</span>

              <span v-if="$store.getters.language === 'SLO'" class=tool-subtitle>Objavljen:</span>
              <span v-else class=tool-subtitle>Published:</span>
              <span>{{items[chosen_idx].created_ts}}</span>

              <b-button class="button-redirect" @click="redirectToGUI(items[chosen_idx].name, items[chosen_idx].name_slo, items[chosen_idx].type, items[chosen_idx].id, items[chosen_idx].git_url, items[chosen_idx].api_doc_url)">
                <span v-if="$store.getters.language === 'SLO'">Preizkusi model</span>
                <span v-else>Check out the model</span>
              </b-button>
              <hr>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModelList",
  mounted() {
  this.$http.get(this.$hostname + '/api/model/list_public')
    .then(response => { 
      this.items = response.data
      this.items = this.items.map(item => ({...item}));
      const chunkSize = 3;
      var counter = 0
      for (let i = 0; i < this.items.length; i += chunkSize) {
          const chunk = this.items.slice(i, i + chunkSize);
          this.sliced_items.push({"counter": counter, "chunk_data": chunk})
          counter += 1
      }
      console.log(this.sliced_items)

    })
    .catch(error => {
      console.error(error);
    });
  },
  data() {
    return {
      items: [],
      sliced_items: [],
      chosen_idx: -1,
    };
  },
  methods: {
    redirectToGUI(name, name_slo, type, id, git_path, api_doc_url) {
      if (type==='Other') {
        console.log('semanticshifttable/' + id)
        this.$router.push({
          name: 'semanticshifttable',
          params: {
            model_id: id,
            model_name: name,
            model_name_slo: name_slo,
            model_git: git_path,
          }
        })
      }
      else if (type==='Gradio Application') {
        window.location.href = api_doc_url
      }
      else if (type==='LLM') {
        this.$router.push({
          name: 'LLMChat',
          params: {
            model_id: id,
            model_name: name,
            model_name_slo: name_slo,
            model_git: git_path,
          }
        })
      }

      else if (type==='Document classification') {
        this.$router.push({
          name: 'documentclassification',
          params: {
            model_id: id,
            model_name: name,
            model_name_slo: name_slo,
            model_git: git_path,
          }
        })
      }
      else if (type==='Sequence labelling') {
        this.$router.push({
          name: 'sequencelabelling',
          params: {
            model_id: id,
            model_name: name,
            model_name_slo: name_slo,
            model_git: git_path,
          }
        })
      }

      else {
        console.log('Type not implemented yet')
      }
    },
    showData(index, counter) {
      if (this.chosen_idx == index) {
        this.chosen_idx = -1
      }
      else {
        if (typeof counter == 'undefined') {
          this.chosen_idx = index
        }
        else {
          this.chosen_idx = counter * 3 + index
        }
      }
    },
  }
}
</script>

<style lang="scss">

thead, tbody, tfoot, tr, td, th {
  text-align: left;
  width: 100px;
  vertical-align: middle;
}
.tool-title {
  text-align: center;
  padding-top: 0px;
  padding-bottom: 0px;
  margin-bottom: 0px;
  font-size: 16px;
  font-weight: 500;
  text-transform: uppercase;
  color:  #fff;
}

.tool-subtitle {
  font-weight: 400 !important;
  text-transform: uppercase;
  padding-bottom: 5px;
  padding-top: 10px;
}

.tool-description {
  text-align: center;
  padding-top: 0px;
  padding-bottom: 0px;
  font-size: 14px;
  font-weight: 300;
  color:  #fff;
  margin-left: 30px;
  margin-right: 30px;
}

.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding-bottom: 20px;
  width: 200px;
}

.button-redirect {
  margin-bottom: 20px;
  margin-top: 10px;
  background: #fff;
  border-radius: 25px;

  span {
    color: #4F6675 !important;
  }
}

.button-redirect:active, .button-redirect:focus, .button-redirect:hover {
  background: #fff !important;
  background-color: #fff !important; 
}

.outer, .inner {
  background: #4F6675;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 20px;
  min-height: 100px;
}

@media (min-width: 700px) {
  .outer, .inner {
    padding-left: 30px;
    padding-right: 30px;
  }
}

@media (max-width: 991px) {
  .outer, .inner {
    text-align: center;
  }
}
  
.inner { 
  background: #4F6675;
}

.inner span{ 
  color: #fff;
  font-size: 14px;
  font-weight: 300;
  display: block;
}

.inner a {
  color: #fff;
  font-size: 14px;
  font-weight: 300;
  text-decoration: underline;
}


.model-item {
  background: #4F6675;
  padding-top: 160px;
  margin-top: 80px;
  padding-bottom: 10px;
  padding-left: 5px;
  padding-right: 5px;
  cursor: pointer;
}

@media (min-width: 992px) {
  .model-item {
      margin-top: 50px;
  }
}

@media (min-width: 992px) {
  .models-row {
      margin-bottom: 50px;
  }
}


@media (min-width: 1201px) {
  .model-item {
      min-height: 200px;
  }
}


@media (min-width: 992px) and (max-width: 1200px) {
  .model-item {
      min-height: 250px;
  }
}

.model-item img {
  margin-top: -225px;
  max-width: 120px;
  padding-bottom: 8px;
}

#model-list-container {
  margin-left: 10%;
  margin-right: 10%;
}

.arrow-down {
  border: #4F6675;
  border-style: solid;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}

</style>